export class EnumUtils {
  public static existsKeyInEnum(key: string, inEnum: any): boolean {
    return Object.values(inEnum).some((k) => k === key);
  }
}
